import Vue from 'vue';
import { formatTicketType } from '@/plugins/api-client/ticket/model';

const getClient = (type) => Vue.api.getClient(type);

export const STATUS = {
  LOADING: 'tickets.status.loading',
  SUCCESS: 'tickets.status.success',
  ERROR: 'tickets.status.error',
};

const initialState = {
  tickets: [],
  status: '',
  resourceList: [],
  error: null,
  total: null,
};

const mutations = {
  loading(state) {
    state.status = STATUS.LOADING;
  },
  success(state, { list, total, resourceList }) {
    state.status = STATUS.SUCCESS;
    state.tickets = list;
    state.total = total;
    state.resourceList = resourceList;
  },
  error(state, error) {
    state.status = STATUS.ERROR;
    state.error = error;
  },
  totalSuccess(state, total) {
    state.total = total;
  },
  resourceListRefresh(state, resourceList) {
    state.resourceList = resourceList;
  },
};

function search({
  start, size, filters, sort, ticketType, asc, user,
}) {
  const type = formatTicketType(ticketType);
  return getClient(type)
    .list(start, size, filters,
      sort, ticketType, asc, user);
}

function searchApprovals({
  start, size, filters,
}) {
  const type = formatTicketType('request');
  return getClient(type)
    .listApprovals(start, size, filters);
}

function buildResourceList(list = []) {
  return list.reduce((acc, item) => {
    const resource = item?.affectedResource;

    if (!resource) {
      return acc;
    }

    const exists = acc.some((r) => r.value === resource.id);

    if (!exists) {
      acc.push({
        value: resource.id,
        label: resource.name,
      });
    }
    return acc;
  }, []);
}

const actions = {
  async list({ commit }, searchArgs) {
    commit('loading');
    try {
      const { list, total } = await search(searchArgs);
      commit('success', { list, total, resourceList: buildResourceList(list) });
    } catch (ex) {
      console.error('exception occurred retrieving tickets', ex);
      commit('error', ex);
    }
  },
  async page({ commit, state }, searchArgs) {
    commit('loading');
    try {
      const { list, total } = await search(searchArgs);
      commit('success', { list: state.tickets.concat(list), total, resourceList: buildResourceList(list) });
    } catch (ex) {
      console.error('exception occurred retrieving tickets', ex);
      commit('error', ex);
    }
  },
  async listApprovals({ commit }, searchArgs) {
    commit('loading');
    try {
      const { list, total } = await searchApprovals(searchArgs);
      commit('success', { list, total, resourceList: buildResourceList(list) });
    } catch (ex) {
      console.error('exception occurred retrieving tickets', ex);
      commit('error', ex);
    }
  },
  async totalApprovalsNext({ commit }) {
    try {
      const { list, total } = await searchApprovals({});
      commit('totalSuccess', total);
      commit('resourceListRefresh', buildResourceList(list));
    } catch (ex) {
      console.error('exception occurred count tickets approvers', ex);
      commit('error', ex);
    }
  },
  updateResourceList({ commit }, resourceList) {
    try {
      commit('resourceListRefresh', resourceList.resourceList);
    } catch (ex) {
      console.error('exception occurred update resource list', ex);
      commit('error', ex);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
};
